import { render, staticRenderFns } from "./unionNoticeEdit.vue?vue&type=template&id=1ee6c138&scoped=true&"
import script from "./unionNoticeEdit.vue?vue&type=script&lang=js&"
export * from "./unionNoticeEdit.vue?vue&type=script&lang=js&"
import style0 from "./unionNoticeEdit.vue?vue&type=style&index=0&id=1ee6c138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee6c138",
  null
  
)

component.options.__file = "unionNoticeEdit.vue"
export default component.exports